// TurnawayService — « demandes sans suite » (PB9, PMS-PHONE-BOOKING-BRIEF §2.1).
//
// L2: the desk records under pms.reservation.write, Réservations reads under
// pms.reservation.read — the capabilities the RPC and the table's policy
// require, so L2 and L4 refuse the same caller. The record is checked by
// pms-core before the round trip; the month is summarised by pms-core.

import { CAPABILITIES, type ActorSource } from '@lemontaigu/platform';
import {
  err,
  ok,
  turnawayProblem,
  turnawaySummary,
  type IsoDate,
  type Result,
  type TurnawayInput,
  type TurnawayMonth,
  type TurnawayRepository,
  type TurnawayService,
} from '@lemontaigu/pms-core';
import { gate } from './services.js';

export class TurnawayServiceImpl implements TurnawayService {
  constructor(
    private readonly repo: TurnawayRepository,
    private readonly actor: ActorSource,
  ) {}

  async record(input: TurnawayInput): Promise<Result<number>> {
    const denied = gate(this.actor, CAPABILITIES.PMS_RESERVATION_WRITE);
    if (denied) return denied;
    const problem = turnawayProblem(input);
    if (problem !== null) return err('validation', problem, { retryable: false });
    return this.repo.record(input);
  }

  async month(propertyCode: string, month: IsoDate): Promise<Result<TurnawayMonth>> {
    const denied = gate(this.actor, CAPABILITIES.PMS_RESERVATION_READ);
    if (denied) return denied;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(month)) return err('validation', 'Mois invalide (AAAA-MM-JJ).', { retryable: false });
    const rows = await this.repo.month(propertyCode, month);
    if (!rows.ok) return rows;
    return ok({ rows: rows.value, summary: turnawaySummary(rows.value) });
  }
}
